import { render, staticRenderFns } from "./MarketingCampaignSyncStatus.vue?vue&type=template&id=b83216a0&scoped=true&"
import script from "./MarketingCampaignSyncStatus.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignSyncStatus.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCampaignSyncStatus.vue?vue&type=style&index=0&id=b83216a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83216a0",
  null
  
)

export default component.exports